<template>
    <div class="m-4">

        <div>
            <h4>{{$t('modify_devices_with_a_csv_file')}}</h4><br>
            <li>{{$t('modify_devices_csv_description')}}</li>

            <br>

          <table class="table w-90 p-2" style="background-color: #eee;max-width: 600px;">
            <tr>
              <td colspan="3">{{$t('example')}}</td>
            </tr>
            <tr>
              <td>SERIAL</td>
              <td>NAME</td>
              <td>TAGS</td>
              <td>RESET_TAG</td>
            </tr>
            <tr>
              <td>...</td>
              <td>...</td>
              <td>...</td>
              <td></td>
            </tr>
          </table>
          <br>
            Serial: format ....<br>
            Name: if blank or empty no update<br>
            Tags: separated by space<br>
            <br>
          <div>
            <h2 v-if="error">{{error}}</h2>
            <h2 v-if="imported">The file has been successfully imported</h2>
          </div>
            <div class="p-4">
                <div class="form horizontal">
                    <div class="form-group row">
                        <label class="col-sm-4 col-lg-2 col-form-label text-right">{{$t('devices_file')}}</label>
                        <div class="col-sm-8 col-lg-10">
                            <div class="form-group">
                                <input class='input-large' ref="fileupload" type="file" @change="handleFileUpload($event)">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-8 offset-sm-4 offset-lg-2">
                            <button class="btn btn-primary" :disabled="!file" @click="submitFile">{{$t('upload')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {HTTP} from '../http-constants'

    export default {
        data() {
            return {
                file: '',
                imported: false,
                error: null,
            }
        },
        methods: {
            handleFileUpload(event) {
                this.imported = false;
                this.error = false;
                this.file = event.target.files[0];
            },
            submitFile() {
                let formData = new FormData();
                let self = this;
                self.imported = false;
                self.error = false;
                formData.append('file', this.file);
                HTTP.post('/trackers/modify/import/', formData, {headers: {'Content-Type': 'multipart/form-data'}})
                    .then(function () {
                        self.file = null;
                        self.$refs.fileupload.value=null;
                        self.imported = true;
                    })
                    .catch(function () {
                        self.error = "Error importing file"
                    });
            },
        },
        mounted: function () {
        }
    }
</script>
